import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogHeaderComponent } from './dialog-header/dialog-header.component';
import { XiloBaseDialogComponent } from './dialog/dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { XiloButtonModule } from '../button/button.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    DialogHeaderComponent,
    XiloBaseDialogComponent,
  ],
  imports: [CommonModule, MatDialogModule, XiloButtonModule, MatIconModule],
  exports: [
    DialogHeaderComponent,
    XiloBaseDialogComponent,
  ]
})
export class XiloDialogModule {}
